export enum LoggedInType {
  GoogleOneTap,
  GoogleSignIn,
  Facebook,
  Wego,
}
